<template>
    <v-container>
        <v-card class="pl-10 pr-10">
            <v-card-title class="pb-0">
                <b>รายงานการตั้งเบิก(ส่งศูนย์)</b>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <UserBranchDropdown :pageCode="pageCode" @onUserBranchChange='setCurrentBranch' 
                @onUserBranchNameChange='setCurrentBranchName'></UserBranchDropdown>
            </v-card-title>
            <v-divider></v-divider>

            <template>
                <v-container>
                    <v-card outlined>
                        <v-card-subtitle class="pb-0">
                        <v-row>
                            <v-col><DatePicker label="ตั้งแต่ วันที่" @dateFormatted="setDateFrom" ></DatePicker></v-col>
                            <v-col><DatePicker label="ถึง วันที่" @dateFormatted="setDateTo" ></DatePicker></v-col>
                            <v-spacer></v-spacer>
                           <v-spacer></v-spacer>
                        </v-row>  
                        <v-row>
                        <!-- <v-col cols="1"> สถานะ </v-col>  -->
                         <v-col cols="3">
                        <v-select
                            v-model="select"
                            :items="listType"
                            item-text="display"
                            item-value="value"
                            label="ประเภทงาน"
                            persistent-hint
                            return-object
                            outlined></v-select>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-col class="text-right">
                                <v-row>
                                    <v-btn  class="ma-2" color="primary" small @click="search"><v-icon>search</v-icon> ค้นหา</v-btn>
                                     <v-btn  class="ma-2" color="primary" small @click="createReport"><v-icon >mdi-floppy</v-icon> สร้างรายงาน</v-btn>
                                </v-row>
                            </v-col>
                            
                        </v-row>    
                       <v-row>
                            <v-col><b>จำนวนใบสั่งซ่อม : {{this.countBpj}} <span style="padding-left:20px ;">รวมยอดใบแจ้งหนี้ : {{this.allSumInvoiceDisplay}} </span></b>  </v-col>
                        </v-row>         
                        </v-card-subtitle>
                    </v-card>
                </v-container>
            </template>

         <template  width="1000px">
            <v-data-table 
                
                :headers="headers"
                :items="items"
                class="pt-5"
                >
            </v-data-table>
         </template>
        </v-card>       
    </v-container>
</template>

<script>

 import UserBranchDropdown from '@/components/Shared/UserBranchDropdown'
 import DatePicker from '@/components/Shared/DatePicker'
import {listWithdrawSummary,exportWithdrawSummary} from '@/api/reports/report-api.js'
import numeral from 'numeral'
export default {
    name: 'withdrawExternal',
    components: {
        UserBranchDropdown,
        DatePicker

    },
   props:["pageCode"],
    data: () => ({
        select: { display: 'เงินสด', value: '2' },
        listType: [
            { display: 'เงินสด', value: '2' },
            { display: 'ประกัน', value: '1' },
            { display: 'เครดิต', value: '3' },
            { display: 'งานภายใน', value: '4' }
        ],
         headers: [
                        // {text: "No", value: "strInvoiceDate",width: "80px"},
                        {text: "ทะเบียน", value: "licenseNo",width: "150px"},
                        {text: "เลขที่ใบสั่งซ่อม", value: "jobNo",width: "150px"},
                        {text: "เลขที่ใบประเมิน", value: "estimateNo",width: "150px"},
                        {text: "เลขที่ใบแจ้งหนี้", value: "invoiceNo",width: "140px"},
                        {text: "วันที่ใบแจ้งหนี้", value: "strInvoiceDate",width: "130px"},
                        {text: "ประเภท", value: "jobType",width: "120px"},
                        {text: "ประกันภัย", value: "insurance",width: "120px"},
                        {text: "ค่าซ่อม", value: "sumServiceDisplay",width: "120px"},//ค่าแรงหักส่วนลดประกันแล้ว
                         {text: "ยอดใบแจ้งหนี้", value: "invoiceAmountDisplay",width: "120px"},
                        {text: "%เบิก", value: "percentWithdrawDisplay",width: "100px"},
                        {text: "ยอดตั้งเบิก", value: "withdrawTotalDisplay",width: "150px"}, //ยอดตั้งเบิกสุทธิ
                        {text: "จ่ายจริง", value: "actualReceiptsDisplay",width: "120px"}
                       
                    ],
        items: [],
        countBpj: 0,
        allSumInvoice: 0,
        allSumInvoiceDisplay: '0.00'
    }),
    methods: {
            setDateFrom(val) {
                  this.dateFrom = val;
            },
            setDateTo(val) {
                  this.dateTo = val;
            },
            setCurrentBranch(branchCode) {
                this.branchCode = branchCode;
            },
            setCurrentBranchName(branchName){
                this.branchName = branchName;
            },
            search(){
                this.$loading(true);
                this.allSumInvoice = 0;
                listWithdrawSummary(this.branchCode,this.select.value,this.dateFrom,this.dateTo).then(response => {
                this.items = response;
                 if (this.items) {
                this.items.forEach((e) => {
                    this.allSumInvoice += e.invoiceAmount;
                    e.sumServiceDisplay = numeral(e.sumService).format('0,0.00');
                    e.withdrawTotalDisplay = numeral(e.withdrawTotal).format('0,0.00');
                    e.actualReceiptsDisplay = numeral(e.actualReceipts).format('0,0.00');
                    e.percentWithdrawDisplay = numeral(e.percentWithdraw).format('0,0.00');
                    e.invoiceAmountDisplay = numeral(e.invoiceAmount).format('0,0.00');
                    });
                    
                     const uniqueValues = new Set(this.items.map(v => v.jobNo));
                     this.countBpj = uniqueValues.size;
                     this.allSumInvoiceDisplay = numeral(this.allSumInvoice).format('0,0.00');
                 }
                this.$loading(false);
                }).catch(()=> {
                    this.$loading(false);
                });
            },
            createReport(){
                this.$loading(true);
                exportWithdrawSummary(this.branchCode,this.branchName,this.select.value,this.dateFrom,this.dateTo);
                this.$loading(false);
            },
    }
}
</script>